import { AbstractParser } from "../../parser";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { User } from "src/app/ui/models/domains/pbm/user/user";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";
import { UserPermission } from "src/app/ui/models/domains/pbm/user/user-permission";
import { UserCompanyInfo } from "src/app/ui/models/domains/pbm/user/user-company-info";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { CompanyParser } from "../company/company.parser";

export class SearchUserParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult: PageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.TotalPerPages);
    pageableResult.setTotalItems(payload.Total);
    pageableResult.setItems(this.parseUserList(payload.Data));
    return pageableResult;
  }

  private parseUserList(payload: any): User[] {
    const userList: User[] = payload.map((i) => {
      const user = new User();
      user.setUserKey(i.UserKey.Value);
      user.setActivate(i.Active);
      user.setName(i.Name);
      user.setEmail(i.Email);
      user.setUserCompanyInfo(this.parseUserCompanyInfo(i.CompanyInfo));
      user.setAllowedCompanies(this.parseAllowedCompanies(i.AllowedCompanies));
      user.setUserRoleList(this.parseUserRoleList(i.UserRoles));
      user.correlatedId = i.CorrelatedId || ""
      return user;
    });
    return userList;
  }

  private parseUserCompanyInfo(payload: any): UserCompanyInfo {
    const userCompanyInfo = new UserCompanyInfo();
    userCompanyInfo.setTelephone(payload ? payload.Telephone : "");
    userCompanyInfo.setFiscalNumber(payload ? payload.FiscalNumber : "");
    userCompanyInfo.setCorporateName(payload ? payload.CorporateName : "");
    userCompanyInfo.setHealthProfessional(payload ? payload.HealthProfessional : "");
    userCompanyInfo.setClassCouncil(payload ? payload.ClassCouncil : "");
    userCompanyInfo.setRegistrationNumber(payload ? payload.RegistrationNumber : "");
    return userCompanyInfo;
  }

  private parseAllowedCompanies(payload: Array<any>): Array<Company> {
    let data: Array<Company> = new Array<Company>();
    const companyParser = new CompanyParser();
    if (Array.isArray(payload)) {
      payload.forEach((p) => {
        data.push(companyParser.parse(p));
      });
    }
    return data;
  }

  private parseUserRoleList(payload: any): UserRole[] {
    const userRoleList: UserRole[] = payload.map((i) => {
      const userRole = new UserRole();
      userRole.setUserRoleKey(i.UserRoleKey.Value);
      userRole.setName(i.Name);
      userRole.setUserPermissionList(this.parseUserPermissionList(i.UserPermissions));
      return userRole;
    });
    return userRoleList;
  }

  private parseUserPermissionList(payload: any): UserPermission[] {
    const userPermissionList: UserPermission[] = payload.map((i) => {
      const userPermission = new UserPermission();
      userPermission.setName(i.Name);
      userPermission.setCode(i.Code);
      return userPermission;
    });
    return userPermissionList;
  }
}
